var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"mx-auto",attrs:{"color":"primary"},on:{"click":_vm.generatePDF}},[_vm._v(" Download")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }